<template>
  <div class="attendance-leave-his-container animated fadeInRight padding">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="员工姓名">
              <el-input v-model="searchForm.staffName" placeholder="请输入员工姓名" clearable />
            </el-form-item>
            <el-form-item label="请假类型">
              <el-select v-model="searchForm.leaveType" placeholder="请选择请假类型" clearable>
                <el-option label="事假" value="1001" />
                <el-option label="病假" value="1002" />
                <el-option label="年假" value="1003" />
                <el-option label="调休" value="1004" />
                <el-option label="婚假" value="1005" />
                <el-option label="产假" value="1006" />
                <el-option label="陪产假" value="1007" />
                <el-option label="丧假" value="1008" />
                <el-option label="补卡假" value="1009" />
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.state" placeholder="请选择状态" clearable>
                <el-option label="审批中" value="1100" />
                <el-option label="已通过" value="1200" />
                <el-option label="已拒绝" value="1300" />
                <el-option label="已撤销" value="1400" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
              <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>请假历史记录</span>
          </div>
          <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="leaveId" label="请假ID" align="center" width="180" />
            <el-table-column prop="staffName" label="申请人" align="center" width="100" />
            <el-table-column prop="leaveTypeName" label="请假类型" align="center" width="100" />
            <el-table-column prop="startTime" label="开始时间" align="center" width="160" />
            <el-table-column prop="endTime" label="结束时间" align="center" width="160" />
            <el-table-column prop="leaveHours" label="时长(小时)" align="center" width="100" />
            <el-table-column prop="reason" label="事由" align="center" show-overflow-tooltip />
            <el-table-column label="附件" align="center" width="80">
              <template slot-scope="scope">
                <el-image
                  v-if="hasAttachment(scope.row.attachmentList)"
                  :src="buildFileUrl(scope.row.attachmentList[0].fileRelId)"
                  :preview-src-list="buildPreviewUrls(scope.row.attachmentList)"
                  fit="cover"
                  style="width: 36px; height: 36px; cursor: pointer;"
                />
                <span v-else class="text-muted">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="stateName" label="状态" align="center" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStateTagType(scope.row.state)" disable-transitions>
                  {{ scope.row.stateName }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="申请时间" align="center" width="160" />
          </el-table>
          <el-pagination
            :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listAttendanceLeaves } from '@/api/attendance/attendanceLeaveAuditApi'

export default {
  name: 'AttendanceLeaveHisList',
  data() {
    return {
      loading: false,
      searchForm: { staffName: '', leaveType: '', state: '' },
      tableData: [],
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this.getList() },
  methods: {
    getStateTagType(state) {
      const map = { '1100': 'warning', '1200': 'success', '1300': 'danger', '1400': 'info' }
      return map[state] || ''
    },
    async getList() {
      try {
        this.loading = true
        const params = { page: this.page.current, row: this.page.size, ...this.searchForm }
        const { data, total } = await listAttendanceLeaves(params)
        this.tableData = data || []
        this.page.total = total || 0
      } catch (e) {
        this.$message.error('获取列表失败：' + (e.message || ''))
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page.current = 1; this.getList() },
    handleReset() { this.searchForm = { staffName: '', leaveType: '', state: '' }; this.getList() },
    handleSizeChange(val) { this.page.size = val; this.getList() },
    handleCurrentChange(val) { this.page.current = val; this.getList() },
    // ============ 附件展示 ============
    hasAttachment(list) {
      return Array.isArray(list) && list.length > 0
    },
    buildFileUrl(fileRelId) {
      if (!fileRelId) return ''
      return `/callComponent/download/getFile/file?fileId=${fileRelId}&communityId=-1&time=${new Date().getTime()}`
    },
    buildPreviewUrls(list) {
      if (!Array.isArray(list)) return []
      return list.map(it => this.buildFileUrl(it.fileRelId))
    }
  }
}
</script>

<style lang="scss" scoped>
.attendance-leave-his-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
  ::v-deep .el-card {
    border-radius: var(--ds-radius-md);
    border: 1px solid var(--ds-gray-300);
    box-shadow: var(--ds-shadow-sm);
    margin-bottom: var(--ds-spacing-lg);
  }
  .search-form { text-align: left; }
}
</style>
